export interface CommissionInterface{
    sku:string;
    carrier:string;
    group:string;
    comision:number;
    com_fija:boolean;
}

export class Commission implements CommissionInterface{
    sku: string;
    carrier: string;
    group: string;
    comision: number;
    com_fija: boolean;

    constructor(c:CommissionInterface){
        this.sku = c.sku;
        this.carrier = c.carrier;
        this.group = c.group;
        this.comision = c.comision;
        this.com_fija = c.com_fija;
    }

}